import { render, staticRenderFns } from "./Receipt.vue?vue&type=template&id=cb0f8f04"
import script from "./Receipt.vue?vue&type=script&lang=js"
export * from "./Receipt.vue?vue&type=script&lang=js"
import style0 from "./Receipt.vue?vue&type=style&index=0&id=cb0f8f04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports